import React, { useRef } from "react";
import { Box } from "@mui/material";
import Sidebar from "./Sidebar";
import MobileTopBar from "./MobileTopBar";
import { Outlet } from "react-router-dom";
import { useAuth } from "../authContext/authContext";
import { usePortal } from "../authContext/portalContext";
import RoleSwitchIndicator from "./portal/RoleSwitchIndicator";
import LanguageSwitcher from "./LanguageSwitcher";
import TwoFactorChoiceDialog from "./TwoFactorChoiceDialog";

function MainLayout() {
  const { isAuthenticated } = useAuth();
  const { activePortal } = usePortal();
  const sidebarRef = useRef(null);
  const showLanguageSwitcher = activePortal === "patient" || activePortal === "therapist";

  return (
    <Box sx={{ display: "flex", flexDirection: "column", height: "100vh", overflow: "hidden" }}>
      {isAuthenticated && (
        <MobileTopBar onMenuClick={() => sidebarRef.current?.openMobile()} />
      )}
      {isAuthenticated && showLanguageSwitcher && <LanguageSwitcher />}

      <Box sx={{ display: "flex", flex: 1, minHeight: 0, overflow: "hidden" }}>
        {/* Conditionally render Sidebar only if user is logged in */}
        {isAuthenticated && <Sidebar ref={sidebarRef} />}
        {isAuthenticated && <RoleSwitchIndicator />}
        {isAuthenticated && <TwoFactorChoiceDialog />}

        {/* Content Area */}
        <Box
          sx={{
            flexGrow: 1,
            overflow: "auto", // Only content scrolls
            p: { xs: 2, md: 3 },
            backgroundColor: "#F1F1F1",
          }}
        >
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
}

export default MainLayout;
